<script lang="ts" module>
  import CtaButton from '@/ui/elements/buttons/CTAButton.svelte';
  import BaseCard from '@/ui/elements/card/BaseCard.svelte';
  import ContentCard from '@/ui/elements/card/ContentCard.svelte';
  import Pagination from '@/ui/elements/pagination/Pagination.svelte';
  import { useActiveTeoText } from '@/ui/state/use-text-state.svelte';

  import TaskMaster from '../Performance/InitCard/cmps/TaskMaster.svelte';
</script>

<script lang="ts">
  let T = useActiveTeoText();
  let TS = $derived($T.store);

  let GS = $derived($T.generatorUi.store);
  async function createText() {
    $T.generatorUi.generateText();
  }
</script>

<div class="flex flex-col space-y-4">
  <ContentCard cardLabel="Deine Aufgabe:">
    <TaskMaster taskLabel="Konfiguriere deinen Text" done={$TS.allPromptOptionsSelected}
    ></TaskMaster>
    <TaskMaster
      taskLabel="Gib ein Inhalts-Briefing ein"
      done={($GS.currentHistory?.instructions.length ?? 0) > 0}
    ></TaskMaster>
  </ContentCard>
  <BaseCard class="relative">
    <form
      onsubmit={(event) => {
        event.preventDefault();
        createText();
      }}
      class="space-y-4"
    >
      <div>
        <div class="flex justify-between">
          <label class="mb-1 block font-bold" for="instructions-textarea">Anlass und Inhalt</label>
          {#if $GS.history.length > 1}
            <Pagination
              pages={$GS.historyPageInfo.total}
              current={$GS.historyPageInfo.current}
              onPageChange={(page) => GS.selectHistory(page)}
            ></Pagination>
          {/if}
        </div>

        <textarea
          id="instructions-textarea"
          value={$GS.currentHistory?.instructions ?? ''}
          oninput={(event) => GS.updateInstructions(event.currentTarget.value)}
          class="w-full rounded-md border border-c-divider p-1"
          rows={6}
          placeholder="Beschreibe hier kurz Anlass und Inhalt für deinen Text..."
        ></textarea>
      </div>
      {#if $GS.currentHistory?.generatorError}
        <div class="text-c-error">
          {$GS.currentHistory?.generatorError?.message}
        </div>
      {/if}
      <div class="flex gap-2">
        <CtaButton
          class="w-full"
          loading={$GS.loading}
          variant={$GS.currentHistory?.locked ? 'primaryfaint' : 'primaryCTA'}
          disabled={($GS.currentHistory?.instructions.length ?? 0) === 0 ||
            !$TS.allPromptOptionsSelected}
          icon="MagicButton"
          type="submit"
        >
          {$GS.currentHistory?.locked ? 'Text erneut generieren...' : 'Neuen Text generieren...'}
        </CtaButton>
      </div>
    </form>
  </BaseCard>
</div>
